import { Component, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { ToastNotificationService } from '../../../core/toast-notification.service';
import { UIBlockingService } from '../../../core/ui-blocking.service';
import { DumbMemberDiscount } from '../DTOs/dumb-member-discount';
import { MemberInformationService } from '../member-information.service';

@Component({
  selector: 'app-claim-member-discount',
  templateUrl: './claim-member-discount.component.html',
  styleUrls: ["../../../../../src/assets/css/discount.css"],
  providers: [UIBlockingService, NgbDropdown],
  encapsulation: ViewEncapsulation.None
})
export class ClaimMemberDiscountComponent {

  constructor(private memberInformationService: MemberInformationService
    , private route: ActivatedRoute
    , private blockUI: UIBlockingService
    , private notificationService: ToastNotificationService) {
  }

  discountId: number;
  discount: DumbMemberDiscount = new DumbMemberDiscount();

  showClaimSuccess: boolean = false;

  ngOnInit() {
    this.discountId = +this.route.snapshot.paramMap.get("discountId");

    this.getDiscountDetails();
  }
  redeem() {
    this.blockUI.start();

    this.memberInformationService
      .claimMemberDiscount(this.discountId).subscribe(
        {
          next: (data) => {
            if (data)
              this.showClaimSuccess = true;
          },
          error: (err) => {
            this.notificationService.error(err.error.message);
            this.blockUI.stop();
            console.log(err)
          },
          complete: () => {
            this.blockUI.stop();
          }
        });
  }

  getDiscountDetails() {
    this.blockUI.start();

    this.memberInformationService
      .getMemberDiscountDetails(this.discountId).subscribe(
        {
          next: (data) => {
            this.discount = data;
          },
          error: (err) => {
            this.notificationService.error(err.error.message);
            this.blockUI.stop();
            console.log(err)
          },
          complete: () => {
            this.blockUI.stop();
          }
        });
  }

}
